// src/services/aiApi.js
/* eslint-disable */
import { client } from "./axiosClient";

/**
 * Generates an AI insight based on a predefined prompt type.
 * @param {string} promptType - The key for the prompt (e.g., 'executive_briefing').
 * @returns {Promise<object>} - A promise that resolves to the API response.
 */
export const generateInsight = async (promptType) => {
  try {
    /*
    console.log(
      "[aiApi] Sending POST request to /api/ai-assistant/ with payload:",
      {
        prompt_type: promptType,
      }
    );
    */

    const response = await client.post("/api/ai-assistant/", {
      prompt_type: promptType,
    });

    // console.log("[aiApi] Successfully received response:", response.data);
    return response.data;
  } catch (error) {
    /*
    console.error(
      `[aiApi] Axios request failed for prompt [${promptType}]:`,
      error
    );

    if (error.response) {
      console.error("[aiApi] Error data:", error.response.data);
      console.error("[aiApi] Error status:", error.response.status);
    } else if (error.request) {
      console.error("[aiApi] No response received:", error.request);
    } else {
      console.error("[aiApi] Error setting up request:", error.message);
    }
    */

    return {
      success: false,
      text: "Failed to connect to the server. Please check your connection and try again.",
    };
  }
};

/**
 * Generates AI insights specific to an initiative based on its One Page history.
 * @param {number} initiativeId - The ID of the initiative to analyze.
 * @returns {Promise<object>} - A promise that resolves to the API response.
 */
export const generateInitiativeInsights = async (initiativeId) => {
  try {
    const response = await client.post("/api/initiative-insights/", {
      initiative_id: initiativeId,
    });

    return response.data;
  } catch (error) {
    console.error(
      `[aiApi] Axios request failed for initiative insights [${initiativeId}]:`,
      error
    );

    return {
      success: false,
      text: "Failed to connect to the server. Please check your connection and try again.",
    };
  }
};

/**
 * Generates AI insights about deliverable gaps for a specific initiative.
 * @param {number} initiativeId - The ID of the initiative to analyze.
 * @returns {Promise<object>} - A promise that resolves to the API response.
 */
export const generateDeliverableInsights = async (initiativeId) => {
  try {
    const response = await client.post("/api/deliverable-insights/", {
      initiative_id: initiativeId,
    });

    return response.data;
  } catch (error) {
    console.error(
      `[aiApi] Axios request failed for deliverable insights [${initiativeId}]:`,
      error
    );

    return {
      success: false,
      text: "Failed to connect to the server. Please check your connection and try again.",
    };
  }
};
